const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "200+", label: "Happy Clients" },
  { value: "8", label: "Core Services" },
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image block */}
          <div className="relative">
            <div className="w-full h-[620px] rounded-lg overflow-hidden">
              <img
                src="/images/about/hvac-plant.webp"
                alt="ISMAN Engineering – industrial HVAC, pipework and process plant installation in Kenya"
                className="w-full h-full object-cover object-[42%_center]"
              />
            </div>
            {/* Floating years badge */}
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white rounded-lg p-6 hidden md:block">
              <p className="text-3xl font-extrabold leading-none">15+</p>
              <p className="text-xs uppercase tracking-widest text-teal-100 mt-1">Years of<br/>Excellence</p>
            </div>
            {/* Floating quality tag */}
            <div className="absolute top-6 -left-4 bg-white border border-gray-100 rounded-lg px-4 py-3 hidden md:flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center bg-teal-50 rounded-full">
                <i className="ri-medal-line text-teal-600 text-lg"></i>
              </span>
              <div>
                <p className="text-xs font-bold text-gray-800 whitespace-nowrap">ISO-Grade Fabrication</p>
                <p className="text-xs text-gray-400 whitespace-nowrap">SS304 · SS316 · Custom Built</p>
              </div>
            </div>
          </div>

          {/* Text block */}
          <div>
            <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest">About ISMAN</span>
            <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight mt-3 leading-tight">
              Engineering<br/>
              <span className="text-teal-600">Excellence</span><br/>
              in Kenya
            </h2>

            <p className="text-gray-500 text-sm leading-relaxed mt-5">
              ISMAN Engineering Company is a leading provider of integrated engineering solutions in Kenya. We specialize in commercial kitchen systems, HVAC, plumbing, welding, and more — delivering precision-engineered results that stand the test of time.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mt-3">
              Our mission is simple: we provide solutions and take away your worries. From initial concept and 3D design to full installation and ongoing maintenance, our expert team is with you every step of the way.
            </p>

            <ul className="mt-6 space-y-3">
              {[
                "Certified and experienced engineering team",
                "End-to-end service from design to maintenance",
                "Trusted by hospitals, hotels and food industries",
                "Competitive pricing with up to 20% savings",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-gray-600">
                  <span className="w-5 h-5 flex items-center justify-center bg-teal-100 rounded-full mt-0.5 shrink-0">
                    <i className="ri-check-line text-teal-600 text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
                className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-7 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Get in Touch
              </a>
              <a
                href="/company-profile"
                className="border border-gray-300 hover:border-teal-500 text-gray-700 hover:text-teal-600 font-semibold px-7 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Company Profile
              </a>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div key={i} className="bg-gray-50 rounded-lg p-6 text-center border border-gray-100">
              <p className="text-3xl font-extrabold text-teal-600">{stat.value}</p>
              <p className="text-xs uppercase tracking-widest text-gray-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
